import { graphqlFetch } from '@pylot-data/graphqlFetch'
import { categorySliderQuery } from '@pylot-data/hooks/category/graphql/categorySliderQuery'

export interface CategoryItem {
    category_id: number
    current: number
    imageUrl: string
    name: string
    position: string
    url: string
    hide_name_in_slider: boolean
}
interface SliderResult {
    CategorySlider: { categoryItems: CategoryItem[] }
}

interface SliderVariables {
    category_id: number
}

async function getCategoriesSlider({
    categoryId
}: {
    categoryId: number
}): Promise<SliderResult | undefined | null> {
    const categorySlider = await graphqlFetch<SliderVariables, SliderResult>({
        query: categorySliderQuery,
        variables: {
            category_id: categoryId
        },
        locale: 'es'
    })

    return categorySlider.data
}

export default getCategoriesSlider
